module.exports = __webpack_public_path__ + "img/hometax.9ace95ac.jpg";